import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {FMHoliday} from '../../../model/holidayVo';
import {ApiService} from '../../../services/api.service';
import {Constants} from '../../../constants/ebtq-constants';
import {ErrorService} from '../../../shared/error-page/service/error-service';
import {UtilityService} from '../../../services/utility-service';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {Title} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-holiday',
  templateUrl: './holiday.component.html',
  styleUrls: ['./holiday.component.scss']
})
export class HolidayComponent implements OnInit {

  constructor(private httpService: HttpClient, private apiService: ApiService, private errorService: ErrorService,
              private titleService: Title, private cdr: ChangeDetectorRef) {
    this.utilService = new UtilityService();
  }

  holidayList: string [];
  cols: any[];
  showErrorDiv = false;
  showHolidayList = false;
  yearVal: number;
  holidayObj: FMHoliday[];
  errHeading: string;
  errMessage: string;
  containsError = false;
  errorMsg: string;
  utilService: UtilityService;
  title = 'Holiday Schedule';

  searchForm = new UntypedFormGroup({
    yearVal: new UntypedFormControl('')
  });

  ngOnInit() {
    this.titleService.setTitle(this.title);
    this.errHeading = Constants.ERROR_HEADER;
    this.errMessage = Constants.HOL_ERR_MESS;
    this.cols = [
      {field: 'name', header: 'Name', width: '125px'},
      {field: 'date', header: 'Date', width: '75px'},
      {field: 'holidayType', header: 'Type', width: '125px'},

    ];
  }

  getHolidayList() {
    this.yearVal = this.searchForm.value.yearVal;
    if (this.yearVal === undefined || this.yearVal === null) {
      this.showErrorDiv = true;
      this.showHolidayList = false;
    } else if (this.yearVal < 1994) {
      this.showErrorDiv = true;
      this.showHolidayList = false;
    } else {
      this.showErrorDiv = false;
      this.apiService.getHolidayList(this.yearVal)
        .subscribe(
          (data: any) => {
            this.showHolidayList = true;
            this.holidayObj = data.holidays;
            this.cdr.detectChanges();
          },
          error => {
            this.errorService.announceError(error);
          });

      // error announcement
      this.errorService.errorAnnouncedSource$.subscribe(
        message => {
          this.errorMsg = message;
          this.containsError = true;
          this.cdr.detectChanges();
        });
    }
  }
}
